var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLiability(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.5 24.5C23.5 24.5 24.5649 24.9726 26.7917 25.8769L24.5252 20.0509L30.1602 17.5684L24.5252 15.0864L26.7917 9.25986L21.0897 11.5759L18.6602 5.81836L16.2307 11.5759L10.5282 9.25986L12.5112 15.3234",
    stroke: "#6F757C",
    strokeWidth: 1.5,
    strokeMiterlimit: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2617 17.581L18.7307 13.0205",
    stroke: "#6F757C",
    strokeWidth: 1.5,
    strokeMiterlimit: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.332 18.9005L21.6995 16.4155",
    stroke: "#6F757C",
    strokeWidth: 1.5,
    strokeMiterlimit: 5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-8 27.5V24.0435C-8 23.064 -7.572 22.133 -6.8285 21.495C-5.811 20.6225 -4.5 19.4975 -4.5 19.4975V19.497C-4.5 16.737 -2.263 14.5 0.497 14.5C2.863 14.5 5.5105 14.5 7.089 14.5C7.9735 14.5 8.802 14.9315 9.3095 15.6555C10.343 17.132 12 19.4975 12 19.4975C12 19.4975 16.0775 20.54 18.7435 21.222C20.071 21.5615 21 22.7575 21 24.128V27.457L-8 27.5Z",
    stroke: "#6F757C",
    strokeWidth: 1.5,
    strokeMiterlimit: 5,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 23H20.426",
    stroke: "#6F757C",
    strokeWidth: 1.5,
    strokeMiterlimit: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5 15L3.583 19.5",
    stroke: "#6F757C",
    strokeWidth: 1.5,
    strokeMiterlimit: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-5 19.5H12",
    stroke: "#6F757C",
    strokeWidth: 1.5,
    strokeMiterlimit: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3.19531 29.957C-1.8146 29.957 -0.695312 28.8377 -0.695312 27.457C-0.695312 26.0763 -1.8146 24.957 -3.19531 24.957C-4.57602 24.957 -5.69531 26.0763 -5.69531 27.457C-5.69531 28.8377 -4.57602 29.957 -3.19531 29.957Z",
    fill: "white",
    stroke: "#6F757C",
    strokeWidth: 1.5,
    strokeMiterlimit: 5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3047 29.957C13.6854 29.957 14.8047 28.8377 14.8047 27.457C14.8047 26.0763 13.6854 24.957 12.3047 24.957C10.924 24.957 9.80469 26.0763 9.80469 27.457C9.80469 28.8377 10.924 29.957 12.3047 29.957Z",
    fill: "white",
    stroke: "#6F757C",
    strokeWidth: 1.5,
    strokeMiterlimit: 5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5 31H31.5",
    stroke: "#6F757C",
    strokeWidth: 1.5,
    strokeMiterlimit: 5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiability);
export default __webpack_public_path__ + "static/media/liability.011853a74a29a66d2dcd097399fc5549.svg";
export { ForwardRef as ReactComponent };